
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/[tickerSymbol]",
      function () {
        return require("private-next-pages/us/[tickerSymbol]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/[tickerSymbol]"])
      });
    }
  